export default __webpack_public_path__ + "static/media/ruler-color-gradient.90fdd618.svg";